
import React,{useState,useEffect} from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

import { locales } from "../constants/locations.js";
import { Route, Routes } from "react-router-dom";
import SearchLanding from "../pages/searchLanding/SearchLanding.jsx";
import PageNotFound from "../components/layout/PageNotFound.jsx";
import CategorySelection from "../pages/CategorySelection.jsx";
import RaidCapacityCalculator from "../pages/RaidCapacityCalculator.jsx";
import SearchSupport from "../pages/SearchSupport/SearchSupport.jsx";
import PressRelease from "../pages/PressRelease/PressRelease.jsx";
import Events from "../pages/Events/Events.jsx";
import NewsRoom from "../pages/NewsRoom/NewsRoom.jsx";
import Distributors from "../pages/Distributors/Distributors.jsx";
import ResourceLibrary from "../pages/ResourceLibrary/ResourceLibrary.jsx";

function SiteRouting() {
  
  const getlocation = useLocation();
  const [loading, setLoading] = useState(true);
  
  const [Location, setLocation] = useState(locales.find((index) => {
      return (
        getlocation.pathname.indexOf("/" + index + "/") !== -1 ||
        getlocation.pathname.indexOf("/" + index) !== -1
      )
    }));

  // Get "en-se" from "/en-se/distributors"
  const urlLocale = getlocation.pathname.split("/")[1]?.toLowerCase();

  const userLang = (urlLocale || 'en-us').toLowerCase(); // Ensure language is in lowercase
  useEffect(() => {
    if(locales?.includes(urlLocale)){
      document.querySelector("html").setAttribute("lang", urlLocale.toLowerCase());
    } else {
      document.querySelector("html").setAttribute("lang", 'en-us');
    }
    // Set text direction based on the language
    if (userLang === 'ar-sa' && (getlocation.pathname.includes("/company/distributors") || getlocation.pathname.includes("/company/newsroom"))) {
      document.documentElement.setAttribute('dir', 'rtl');
    } else {
      document.documentElement.setAttribute('dir', 'ltr');
    }
  }, []);

  useEffect(() => {
    const loca = window.location.pathname.split("/")[1] || "en-us";
    const newLang = locales.includes(loca) ? loca : "en-us";

    if (i18n.language !== newLang) {
      i18n.changeLanguage(newLang).then(() => {
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [getlocation.pathname]); 


  useEffect((props) => {
    const localeArray = locales;
    var currentLocale = localeArray.find((index) => {
      return (
        getlocation.pathname.indexOf("/" + index + "/") !== -1 ||
        getlocation.pathname.indexOf("/" + index) !== -1
      );
    });
    setLocation(currentLocale !== undefined ? "/" + currentLocale : "");
  }, []);

  if (loading) {
    return <></>;
  }
  
  return (
    <Routes>
      <Route path={Location+"/search"} element={<SearchLanding />} />
      <Route path={Location} element={<SearchLanding />} />
      <Route path="/search-support" element={<SearchSupport />} />
      <Route path="/support/search-support" element={<SearchSupport />} />
      {/* <Route path="/events" element={<Events />} /> */}
      <Route path={Location +"/company/distributors"} element={<Distributors />} />
      <Route path={Location +"/company/newsroom"} element={<NewsRoom />} />
      <Route path={Location+"/support/category-selection"} element={<CategorySelection />} />
      <Route path={Location+"/support/resource-library"} element={<ResourceLibrary />} />
      <Route path={Location+"/support/store"} element={<ResourceLibrary />} />
      {/* <Route path={Location+"/newsroom/press-releases"} element={<PressRelease />} /> */}

      <Route path={Location+"/raid-capacity-calculator"} element={<RaidCapacityCalculator />} />
      <Route path={Location + "*"} element={< PageNotFound />} />
    </Routes>
  );
}
export default SiteRouting;
